import { helpers } from './helpers';

export default () => {
    const videos = document.querySelectorAll('.lazy-video');

    // Immedietly load poster
    videos.forEach((video) => {
        if (video.classList.contains('lazy-video--immediately-load-poster')) {
            video.setAttribute('poster', helpers.isPhone() ? video.dataset.posterMobile : video.dataset.posterDesktop);
        }
    });

    const callback = (entries) => {
        entries.forEach((video) => {
            if (video.isIntersecting) {
                if (!video.target.classList.contains('lazy-video--immediate')) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];

                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            const loadOrientation =
                                video.target.dataset.swap === 'true'
                                    ? helpers.isPortrait()
                                        ? videoSource.dataset.srcMobile
                                        : videoSource.dataset.srcDesktop
                                    : videoSource.dataset.srcMobile;

                            if (video.target.classList.contains('lazy-video--single')) {
                                videoSource.src = videoSource.dataset.src;
                            } else {
                                videoSource.src = helpers.isPhone() ? loadOrientation : videoSource.dataset.srcDesktop;
                            }
                        }
                    }

                    video.target.load();
                }
                video.target.classList.remove('lazy-video');

                lazyVideoObserver.unobserve(video.target);

                if (video.target.dataset.autoplay === 'false') return;

                video.target.play().catch(() => {
                    if (video.target.classList.contains('video--loop')) return;

                    // Autoplay not allowed, show play button
                    handleBlockedAutoplay(video.target);
                });
            }
        });
    };

    const lazyVideoOptions = {
        rootMargin: `+${window.innerHeight * 2}px`,
        threshold: 0,
    };

    // Fix for infinite loop videos
    const loopVideoOptions = {
        root: document.querySelector('.loop__track'),
        rootMargin: `0% 100%`,
        threshold: 0,
    };

    const lazyVideoObserver = new IntersectionObserver(callback, lazyVideoOptions);
    const loopVideoObserver = new IntersectionObserver(callback, loopVideoOptions);

    videos.forEach((video) => {
        const shouldSwapVideos = video.dataset.swap === 'true' && helpers.isPhone();
        const loadOrientation = shouldSwapVideos
            ? helpers.isPortrait()
                ? video.dataset.posterMobile
                : video.dataset.posterDesktop
            : video.dataset.posterMobile;

        if (
            !video.classList.contains('lazy-video--immediately-load-poster') &&
            !video.classList.contains('lazy-video--skip-poster')
        ) {
            if (video.classList.contains('lazy-video--single')) {
                video.setAttribute('poster', video.dataset.poster);
            } else {
                video.setAttribute('poster', helpers.isPhone() ? loadOrientation : video.dataset.posterDesktop);
            }
        }

        if (!video.classList.contains('video--loop')) {
            lazyVideoObserver.observe(video);
        } else {
            // Call infinite loop video observer
            loopVideoObserver.observe(video);
        }

        if (!shouldSwapVideos) return;

        handleOrientationChange(video);
    });
};

const handleBlockedAutoplay = (video) => {
    const overlay = video.nextElementSibling;
    const nest = video.closest('.video');

    overlay.classList.add('video__overlay--show');
    overlay.addEventListener('click', () => {
        if (nest) {
            nest.classList.remove('video--with-events');
        }
        overlay.classList.remove('video__overlay--show');

        video.play();
    });

    video.addEventListener('play', () => {
        overlay.classList.remove('video__overlay--show');
    });

    if (nest) {
        nest.classList.add('video--with-events');
    }
};

const handleOrientationChange = (video) => {
    const videoSource = video.children[0];

    screen.orientation.addEventListener('change', () => {
        if (screen.orientation.type.includes('portrait')) {
            videoSource.src = videoSource.dataset.srcMobile;
            video.setAttribute('poster', video.dataset.posterMobile);
            video.load();
        } else {
            videoSource.src = videoSource.dataset.srcDesktop;
            video.setAttribute('poster', video.dataset.posterDesktop);
            video.load();
        }
    });
};
